import CreditCardApplyForm from 'components/Content/CreditCards/CreditCardApplyForm/CreditCardApplyForm';
import { withCreditCardApplyFormProps } from 'viewModel/content/creditCards/creditCardApplyForm/withCreditCardApplyFormProps';

export default withCreditCardApplyFormProps(CreditCardApplyForm);
